var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loader",class:_vm.classes},[_c('div',{staticClass:"loader__box"},[(_vm.label)?_c('p',{staticClass:"loader__box__label",attrs:{"data-testid":"loader-label"}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('nb-spinner')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }